import { render, staticRenderFns } from "./Turn.vue?vue&type=template&id=3ecdb2b9&scoped=true&lang=pug&"
import script from "./Turn.vue?vue&type=script&lang=js&"
export * from "./Turn.vue?vue&type=script&lang=js&"
import style0 from "./Turn.vue?vue&type=style&index=0&id=3ecdb2b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecdb2b9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ecdb2b9')) {
      api.createRecord('3ecdb2b9', component.options)
    } else {
      api.reload('3ecdb2b9', component.options)
    }
    module.hot.accept("./Turn.vue?vue&type=template&id=3ecdb2b9&scoped=true&lang=pug&", function () {
      api.rerender('3ecdb2b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/virtualrowFSFB/components/Turn.vue"
export default component.exports